import { render } from "./InterestDemoTransactions.vue?vue&type=template&id=63d05d2a&scoped=true"
import script from "./InterestDemoTransactions.vue?vue&type=script&lang=js"
export * from "./InterestDemoTransactions.vue?vue&type=script&lang=js"

import "./InterestDemoTransactions.vue?vue&type=style&index=0&id=63d05d2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d05d2a"]])

export default __exports__